import React from 'react'
import Slider from 'rc-slider'
import styled from 'styled-components'

import 'rc-slider/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'

const Handle = Slider.Handle

class ControllerRange extends React.Component {
  handle = (props) => {
    const { value, ...restProps } = props
    if (value !== this.props.value) {
      this.props.update(value)
    }
    return <Handle value={value} {...restProps} />
  }

  render() {
    const { min, max, className, recommended, value, id } = this.props
    return (
      <div className={className} id={id && `${id}-controllerRange`}>
        <Slider min={min} max={max} defaultValue={value || recommended} handle={this.handle} />
        <span className="value-displayed">{`${value}%`}</span>
        <div className="mt fss">
          Recommended percentage:
          <span className="recommended-value">{` ${recommended}%`}</span>
        </div>
      </div>
    )
  }
}

export default styled(ControllerRange)`
  pointer-events: ${(props) => (props.enabled ? 'all' : 'none')};
  padding-left: 30px;
  .rc-slider {
    display: inline-block;
    vertical-align: middle;
    width: 400px;
    margin-right: 15px;
  }
  .rc-slider-rail,
  .rc-slider-track {
    height: 2px;
    background-color: ${(props) => (props.enabled ? '#0152CC' : '#EEF4F7')};
  }
  .rc-slider-handle {
    width: 21px;
    height: 21px;
    border: solid 1px ${(props) => (props.enabled ? '#0152CC' : '#CACACA')};
    margin-top: -10px;
    &:hover {
      border: solid 2px ${(props) => (props.enabled ? '#0152CC' : '#CACACA')};
    }
    &:focus,
    &:active {
      border-color: ${(props) => (props.enabled ? '#0152CC' : '#CACACA')};
      box-shadow: none;
    }
  }
  .value-displayed {
    font-weight: 600;
    color: ${(props) => (props.enabled ? '#000000' : '#999999')};
  }
`
